import { eachDayOfInterval, isWeekend } from 'date-fns';
import {
  getNextDay,
  getNextMonth,
  getNextWeek,
  getPreviousDay,
  getPreviousMonth,
  getPreviousWeek,
} from './dateService';
import { ViewMode as ActivityViewMode } from '../models/preferences';
import { ROLES_ID } from '../models/employee';
import { ViewMode } from '../models/reports';
import { UseUserRolesReturn } from '../hooks/useUserRoles';

export function getTotalHoursIntervalToReach(
  startDate: Date,
  endDate: Date
): number {
  const intervalDate = eachDayOfInterval({
    start: startDate,
    end: endDate,
  });
  const employeeNormHours = 8;

  return intervalDate.reduce((prev, current) => {
    if (isWeekend(current)) {
      return prev;
    }

    return prev + employeeNormHours;
  }, 0);
}

export function getNextDate(
  dateActivity: Date,
  viewMode: ActivityViewMode
): Date {
  switch (viewMode) {
    case ActivityViewMode.DAY:
      return getNextDay(dateActivity);
    case ActivityViewMode.MONTH:
    case ActivityViewMode.OLD_VIEW:
      return getNextMonth(dateActivity);
    default:
      return getNextWeek(dateActivity);
  }
}

export function getPreviousDate(
  dateActivity: Date,
  viewMode: ActivityViewMode
): Date {
  switch (viewMode) {
    case ActivityViewMode.DAY:
      return getPreviousDay(dateActivity);
    case ActivityViewMode.OLD_VIEW:
    case ActivityViewMode.MONTH:
      return getPreviousMonth(dateActivity);
    default:
      return getPreviousWeek(dateActivity);
  }
}

export function isValidViewModeForRoleId(
  viewMode: ViewMode,
  userRoles: UseUserRolesReturn
): boolean {
  const { isAdmin, isTeamLead, isProjectManager } = userRoles;
  if (isAdmin) {
    return true;
  }

  if (viewMode === ViewMode.PEOPLE) {
    return isTeamLead;
  }

  if (viewMode === ViewMode.PROJECT) {
    return isProjectManager;
  }

  return false;
}

export function getUserRoleIdByViewMode(viewMode: ViewMode): string {
  switch (viewMode) {
    case ViewMode.PEOPLE:
      return ROLES_ID.TEAM_LEAD;

    case ViewMode.PROJECT:
      return ROLES_ID.PROJECT_MANAGER;

    default:
      return ROLES_ID.TEAM_LEAD;
  }
}
